import { Trans } from 'react-i18next';
import PageHeader from 'components/pageHeader/PageHeader';
import { PropertyBusinessType } from 'models/Properties';
import PropertyEditPermissionInfo from '../common/PropertyEditPermissionInfo';
import usePropertySettingsInitData from '../usePropertySettingsInitData';
import DirectBookingReviewsSection from './sections/directBookingReviews/DirectBookingReviewsSection';
import AirbnbGuestReviewsSection from './sections/airbnbGuestReviews/AirbnbGuestReviewsSection';
import BookingDotComQualityScore from './sections/bookingDotComQualityScore/BookingDotComQualityScore';

const PropertySettingsReviewsTab = () => {
  const { property, isLoading: isLoadingInitData } =
    usePropertySettingsInitData();

  const isStandaloneProperty =
    property?.businessType === PropertyBusinessType.STANDALONE_PROPERTY;
  const isUnitType = property?.businessType === PropertyBusinessType.UNIT_TYPE;

  return (
    <div>
      <PropertyEditPermissionInfo />

      <PageHeader
        className="tab-title"
        title={
          <Trans
            i18nKey="pageProperty.reviews.tabTitle"
            values={{ propertyName: property?.name }}
            components={{ 1: <span className="green" /> }}
          />
        }
        isLoading={isLoadingInitData}
        noDivider
      />

      <DirectBookingReviewsSection />

      <AirbnbGuestReviewsSection />

      {(isStandaloneProperty || isUnitType) && <BookingDotComQualityScore />}
    </div>
  );
};

export default PropertySettingsReviewsTab;
